import {Component} from '@angular/core';
import {WizardPageBaseComponent} from '@utils-lib';
import {HandelsregistereintragAngaben} from '@nachdigal';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'common-ui-handelsregistereintrag-angaben',
  templateUrl: './handelsregistereintrag-angaben.component.html'
})
export class HandelsregistereintragAngabenComponent extends WizardPageBaseComponent<HandelsregistereintragAngaben> {

  static nutzdatenPath = 'handelsregistereintragAngaben';
  static route = 'handelsregistereintrag-angaben';

  constructor(protected readonly activatedRoute: ActivatedRoute) {
    super(activatedRoute);
  }

  public onHandelsregistereintragPicked(handelsregistereintrag: HandelsregistereintragAngaben): void {
    this.data = {
      ...handelsregistereintrag,
      handelsregisterNummer: handelsregistereintrag.handelsregisterNummer?.replace(/\D/g, '')
    };
  }

  protected getStammdatenMappingRules(): Map<string, unknown | Array<unknown>> {
    return new Map<string, unknown | Array<unknown>>([
      ['istErfolgt', this.stammdaten?.unternehmen?.handelsregistereintrag?.istErfolgt],
      ['eingetragenAm', this.stammdaten?.unternehmen?.handelsregistereintrag?.eingetragenAm],
      ['handelsregisterBezeichnung', this.stammdaten?.unternehmen?.handelsregistereintrag?.handelsregisterBezeichnung],
      ['handelsregisterNummer', this.stammdaten?.unternehmen?.handelsregistereintrag?.handelsregisterNummer?.replace(/\D/g, '')],
      ['ortRegistergericht', this.stammdaten?.unternehmen?.handelsregistereintrag?.ortRegistergericht]
    ]);
  }
}
